<ul class="grid row">
    <li *ngFor="let style of styles" [class.active]="current.styleId === style.id" class="col-3">
        <figure (click)="selectStyle(style.id)">
            <span class="media">
                <img *ngIf="style.img !== ''" [src]="'assets/img/'+style.img" [alt]="style.title">
                <span class="state">
                    <svg class="icon-action-select-thumb" aria-hidden="true">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/img/icons.svg#icon-action-select-thumb"></use>
                    </svg>
                </span>
            </span>
            <figcaption>
                {{ style.title | translate }}
            </figcaption>
        </figure>
    </li>
</ul>
<div class="text-center">
    <label class="bt-text" (click)="selectStyle(0)">{{ "need_mapping.no_choice.info" | translate }}</label>
</div>